import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { MessageBoxComponent, MessageBoxType } from '../shared/message-box/message-box.component';
import { OverlayManagerService } from './overlay-manager.service';

@Injectable()
export class MessageBoxService {
    private modalRef;
    private leaveBackgroundBlurredOnClose = false;

    isMessageBoxClosed = new Subject<boolean>();
    constructor(private modalService: NgbModal,
        private overlayManager: OverlayManagerService) { }

    // Sample call from component :
    // this.messageBoxService.displayMessageBox('Message', MessageBoxType.Info, this.callback.bind(this), 'Title');

    // Sample callback function (assignment of the callback functions to each button, omit the ones that are not displayed for the Message Box Type) :
    // callback(button)
    // {
    //     switch (button)
    //     {
    //         case MessageBoxButton.Yes:
    //             alert('yes button clicked');
    //             break;
    //         case MessageBoxButton.No:
    //             alert('no button clicked');
    //             break;
    //         case MessageBoxButton.Cancel:
    //             alert('cancel button clicked');
    //             break;
    //         case MessageBoxButton.Ok:
    //             alert('ok button clicked');
    //             break;
    //     }
    // }

    public displayMessageBox(message: string, messageBoxType: MessageBoxType, callback?: Function, closeCallback?: Function, title?: string, leaveBackgroundBlurred?: boolean) {
        this.closeMessageBox();

        this.overlayManager.toggleBlurBackground.next(true);
        this.leaveBackgroundBlurredOnClose = leaveBackgroundBlurred || false;

        this.modalRef = this.modalService.open(MessageBoxComponent, { backdrop: 'static', keyboard: false });
        this.modalRef.componentInstance.title = title || 'SMRTScape';
        this.modalRef.componentInstance.message = message;
        this.modalRef.componentInstance.messageBoxType = messageBoxType;
        this.modalRef.componentInstance.leaveBackgroundBlurredOnClose = this.leaveBackgroundBlurredOnClose;

        this.overlayManager.hideProcessingOverlay.next();

        this.modalRef.componentInstance.callback = (param) => {
            if (!this.leaveBackgroundBlurredOnClose) this.overlayManager.toggleBlurBackground.next(false);

            if (callback) {
                callback(param);
            }
        };

        this.modalRef.componentInstance.closeCallback = () => {
            if (closeCallback) {
                closeCallback();
            }
        }
    }

    public closeMessageBox() {
        this.overlayManager.toggleBlurBackground.next(false);

        if (this.modalRef) {
            this.modalRef.close();
            // this.isMessageBoxClosed.next(true);
        }
    }

    public isOpen() {
        return this.modalRef.isOpen;
    }
}
